import React, { useState } from "react";
import FormText from "../../../../../../components/Forms/FormText";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { FormHidden } from "../../../../../../components/Forms/FormHidden";
import { TextField } from "@mui/material";
import TranslationWrapper from "../../../../../../components/TranslationWrapper/TranslationWrapper";
import { useWatch } from "react-hook-form";

function BackgroundImage({ name, required }: JSInputProps) {
  const initialValue = useWatch({ name });
  const [url, setUrl] = useState<string | null>((initialValue ?? "").replace(/^url\('/, "").replace(/'\)$/, ""));

  return (
    <>
      <FormHidden name={name} value={`url('${url}')`} />
      <TextField
        onChange={(e) => setUrl(e.currentTarget.value)}
        placeholder={"https://img.jamezz.com/my-image.png"}
        rules={{ required }}
        sx={{
          width: 1,
        }}
      />
      <div>
        {typeof url === "string" && url.length > 0 ? (
          <>
            <TranslationWrapper tDefault={"Preview: "} tKey={"live-interface.image-preview.preview"} />
            <img alt={"Image not found, is your url correct?"} src={url} style={{ maxWidth: "100%" }} />
          </>
        ) : null}
      </div>
    </>
  );
}

export const JSBackgroundImageComponent: JSInputComponent = {
  Component: BackgroundImage,
  handlesCssProperties: ["backgroundImage"],
};
